import {PortfolioType} from "../../portfolio/models/Portfolio";
import {IsoDateTime} from "../../pseudo-types/DateTypes";

export type AccountBriefRecords = ReadonlyArray<AccountBriefRecord>;

export interface AccountBriefRecord {
    readonly id: number;
    readonly number: string;
    readonly name: string;
    readonly portfolioType: PortfolioType;
    readonly ownerId: number | null;
    readonly created: IsoDateTime;
}

export type AccountIds = ReadonlyArray<number>;

export function brokerAccounts(accounts: AccountBriefRecords): AccountBriefRecords {
    return accounts.filter((a) => a.portfolioType === PortfolioType.BROKER);
}

export function simulatedAccounts(accounts: AccountBriefRecords): AccountBriefRecords {
    return accounts.filter((a) => a.portfolioType === PortfolioType.SIMULATED);
}
